/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

import { updateRouterHistory, validateRoute } from './routerNavGuard';

// Composables
import { createRouter, createWebHistory } from 'vue-router/auto';

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: getLayoutTopPadding(),
      };
    }

    return { top: 0 };
  },
});

const getLayoutTopPadding = () => {
  const mainElement = document.querySelector('main');
  if (!mainElement) {
    return 0;
  }
  return parseFloat(
    getComputedStyle(mainElement).paddingTop,
  );
};

router.beforeEach(async (to, from, next) => {
  await validateRoute(to, from, next);
  await updateRouterHistory(to, from, next);
});

export default router;
